import { useState } from 'react';

export default function Hero() {
  const [query, setQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = query.trim();
    if (kw) {
      window.open(`https://www.baidu.com/s?wd=${encodeURIComponent(kw + ' 看料心得')}`, '_blank', 'noopener');
    }
  };

  return (
    <section id="home" className="relative overflow-hidden">
      <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-secondary-200/50 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-28 top-40 h-72 w-72 rounded-full bg-accent-200/40 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-6xl items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.05fr_0.95fr]">
        <div className="text-center lg:text-left">
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
            <i className="ri-fire-fill"></i>
            看料心得经验分享聚集地
          </span>
          <h1 className="mt-5 text-3xl font-bold leading-snug tracking-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
            来了就能找到同好，
            <br />
            一起把「料」聊明白
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-foreground-600 lg:mx-0 md:text-lg">
            无论是追剧看片、游戏通关，还是数码、职场、生活的各种看料体会，都能在这里分享真实感受、讨论热门话题。新手老手，畅所欲言，互动氛围好到不想走。
          </p>

          <form
            onSubmit={handleSearch}
            className="mx-auto mt-7 flex w-full max-w-md flex-col gap-2 sm:flex-row sm:items-center lg:mx-0"
          >
            <label className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-200 transition">
              <i className="ri-search-line text-foreground-400 text-lg"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                type="search"
                placeholder="搜看料心得、话题或领域…"
                aria-label="搜索看料心得与话题"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </label>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              去搜一搜
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-foreground-600 lg:justify-start">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-community-line text-accent-600"></i> 12万+料友
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-message-3-line text-accent-600"></i> 58万+次互动
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-team-line text-accent-600"></i> 每天都有新料
            </span>
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl border border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20coral%20and%20cream%20flat%20illustration%20of%20a%20friendly%20online%20community%20of%20people%20chatting%20in%20speech%20bubbles%2C%20sharing%20content%20cards%20about%20movies%20games%20and%20gadgets%2C%20cozy%20lounge%20scene%20with%20sofa%20and%20lamp%2C%20soft%20peach%20background%2C%20playful%20discussion%20vibe%2C%20minimal%20editorial%20illustration%2C%20clean%20and%20inviting&width=1000&height=760&seq=kanliao-hero&orientation=portrait"
              alt="看料社里料友们围坐畅聊分享看料心得的温暖插画"
              className="h-64 w-full object-cover object-top sm:h-96 lg:h-[440px]"
            />
          </div>
          <div className="absolute -bottom-4 left-4 rounded-xl border border-background-200/70 bg-background-50 px-4 py-3 shadow-sm">
            <p className="flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-verified-badge-fill text-accent-600"></i> 今日新帖
            </p>
            <p className="mt-1 font-heading text-xl font-bold text-foreground-950">236 篇心得</p>
          </div>
          <div className="absolute -top-4 right-4 flex items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-background-50">
            <i className="ri-chat-heart-line"></i>
            <span className="text-sm font-semibold whitespace-nowrap">畅所欲言</span>
          </div>
        </div>
      </div>
    </section>
  );
}